import React from "react"

const BackfillReportableFieldContext = React.createContext(null)

export default BackfillReportableFieldContext
